import { Box, Stack } from '@mantine/core'
import { useLingui } from '@lingui/react/macro'
import { getYearDisplay, MaintenanceTask, SeasonData } from './utils'
import { SeasonHeader } from './SeasonHeader'
import { TaskCard } from './TaskCard'

interface SeasonCardProps {
  season: SeasonData
  onTaskClick: (task: MaintenanceTask, seasonKey: string, year: number) => void
  onAddTask: () => void
  onPrevious?: () => void
  onNext?: () => void
  hasPackage: boolean
}

export function SeasonCard({
  season,
  onTaskClick,
  onAddTask,
  onPrevious,
  onNext,
  hasPackage,
}: SeasonCardProps) {
  const { t } = useLingui()
  const totalOwnTasks = season.tasks.length
  const completedOwnTasks = season.tasks.filter((task) => task.completed).length
  const totalRecommendedTasks = season.recommendedTasks.length
  const completedRecommendedTasks = season.recommendedTasks.filter(
    (task) => task.completed,
  ).length
  const totalMarkkuTasks = season.markkuTasks.length
  const completedMarkkuTasks = season.markkuTasks.filter(
    (task) => task.completed,
  ).length

  const handleTaskClick = (task: MaintenanceTask) => {
    onTaskClick(task, season.season, season.year)
  }

  return (
    <Box
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <SeasonHeader
        backgroundImage={season.backgroundImage}
        title={t(season.seasonName)}
        dateRange={`${t(season.monthRange)} ${getYearDisplay(season.season, season.year)}`}
        totalCost={season.totalCost}
        onPrevious={onPrevious}
        onNext={onNext}
      />

      <Stack style={{ flex: 1 }}>
        <TaskCard
          title={t`My tasks`}
          tasks={season.tasks}
          completedCount={completedOwnTasks}
          totalCount={totalOwnTasks}
          taskType="user"
          onTaskClick={handleTaskClick}
          onAddTask={onAddTask}
          emptyMessage={t`No personal tasks for this season`}
        />

        {totalRecommendedTasks > 0 && (
          <TaskCard
            title={t`Recommended tasks`}
            tasks={season.recommendedTasks}
            completedCount={completedRecommendedTasks}
            totalCount={totalRecommendedTasks}
            taskType="user"
            onTaskClick={handleTaskClick}
            emptyMessage={t`No recommended tasks for this season`}
          />
        )}

        {hasPackage && (
          <TaskCard
            title={t`Markku handles`}
            tasks={season.markkuTasks}
            completedCount={completedMarkkuTasks}
            totalCount={totalMarkkuTasks}
            taskType="markku"
            onTaskClick={handleTaskClick}
            emptyMessage={t`No Markku tasks for this season`}
          />
        )}
      </Stack>
    </Box>
  )
}
